import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import { DataMap } from '@grapecity/wijmo.grid'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, EquipmentFluidCapacity, FluidCompartment, Grid, ListItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { FluidCapacityModalComponent } from './fluid-capacity-modal.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    selector: 'app-fluid-capacity-list',
    templateUrl: './fluid-capacity-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class FluidCapacityListComponent extends BaseComponent implements OnChanges {
    @Input() compartment!: FluidCompartment
    @Input() canEdit = false
    @Input() equipmentOptions: ListItem<string>[] = []
    @Input() equipmentDataMap!: DataMap
    @Input() allItems: EquipmentFluidCapacity[] = []
    @Input() parent!: PartsFluidsEquipmentContext

    grid: Grid<EquipmentFluidCapacity>

    constructor() {
        super()
        this.grid = new Grid<EquipmentFluidCapacity>(this.services, 'equipment', this)
            .setupModalEditing(
                this.services.data.equipmentFluidCapacities,
                'Fluid Capacity',
                FluidCapacityModalComponent,
                () => {
                    const item = new EquipmentFluidCapacity()
                    item.id = crypto.randomUUID()
                    item.compartment = this.compartment
                    return item
                },
                this,
                ModalSize.large,
            )
            .filterBy(item => [
                item.equipment,
                item.fluidSpecification,
                item.viscosityGrade,
                item.notes,
            ])
    }

    ngOnChanges() {
        this.applyItems()
    }

    applyItems() {
        this.grid.items = this.allItems.filter(x => x.compartment === this.compartment)
    }
}
